module.exports = __webpack_public_path__ + "33f89bdfbaf593278eb9ae95f79f3a72.pdf";